import { render } from "./actice_devices.vue?vue&type=template&id=634c5c5f&scoped=true"
import script from "./actice_devices.vue?vue&type=script&lang=js"
export * from "./actice_devices.vue?vue&type=script&lang=js"

import "./actice_devices.vue?vue&type=style&index=0&id=634c5c5f&scoped=true&lang=css"

import exportComponent from "F:\\code\\my_business\\giaiphapmmo_business_2023\\front_end\\company_for_tax\\admin_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634c5c5f"]])

export default __exports__